import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Panel from 'beam/dist/Panel'
import BeamIcon from 'beam/dist/BeamIcon'
import { withStyles } from 'beam/dist/styles'

import TextContent from './TextContent'
import { CONTACT_TYPE } from '../MediaPlayer/mediaPlayer.constants'
import ErrorBoundary from '../ErrorBoundary'

const dataTestIdPrefix = 'App-Recordings-MediaPlayer-TextPanel-'

const styles = theme => ({
  panelBody: {
    padding: theme.spacing(2),
    overflowY: 'auto',
  },
})

const TextPanel = props => {
  const { classes, t, ...contentProps } = props
  const { contactType } = contentProps

  let title, icon

  if (contactType === CONTACT_TYPE.EMAIL) {
    title = t('email')
    icon = <BeamIcon>Email</BeamIcon>
  } else {
    title = t('text')
    icon = <BeamIcon>Text</BeamIcon>
  }

  return (
    <Panel
      dense
      title={title}
      titleIcon={icon}
      variant="light"
      classes={{ body: classes.panelBody }}
      dataTestId={`${dataTestIdPrefix}panel`}
    >
      <ErrorBoundary key={contentProps.ccrid}>
        <TextContent {...contentProps} />
      </ErrorBoundary>
    </Panel>
  )
}

TextPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  ccrid: PropTypes.number,
  /** type of Contact, should only be TEXT or EMAIL */
  contactType: PropTypes.oneOf(['EMAIL', 'TEXT']),
}

export { TextPanel as UnstyledTextPanel }
export default withStyles(styles)(withTranslation()(TextPanel))
